import { render, staticRenderFns } from "./HiDotsHorizontal.vue?vue&type=template&id=4952ee88"
import script from "./HiDotsHorizontal.vue?vue&type=script&lang=ts"
export * from "./HiDotsHorizontal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports